<template>
  <div>
    <a-modal
      :title="modalTitle"
      v-model="visible" 
      @cancel="handleCancel" 
      width="850px"
      v-bind:body-style="{ height: '300px' }"
    >
    <!-- 表单 -->
    <div >
      <a-form-model :label-col="labelCol" :wrapper-col="wrapperCol" :model="searchList" :rules="rules" ref="ruleForm">
        <a-row>
          <a-col :span = "12">
            <a-form-model-item label="企业名称:" prop="comName">
              <a-input v-model="searchList.comName" :allowClear="true" placeholder="请输入企业名称"/>
            </a-form-model-item>
          </a-col>
          <a-col :span = "12">
            <a-form-model-item label="信用代码:" prop="uscc">
              <a-input v-model="searchList.uscc" :allowClear="true" placeholder="请输入信用代码"/>
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row>
          <a-col :span = "12">
            <a-form-model-item label="所在区域:" prop="location">
              <a-input v-model="searchList.location" :allowClear="true" placeholder="请输入所在区域"/>
              <!-- <a-input v-model="searchList.custName" :allowClear="true" disabled>
                <a-icon type="ellipsis" slot="addonAfter" style="cursor: pointer;" @click="selectFn()"/>
              </a-input> -->
              <!-- <a-select v-model="searchList.location"  placeholder="请选择所在区域">
                <a-select-option v-for="item in goodsDiscounts" :key="item.value" :value="item.value" style="width: 120px">
                    {{ item.label }}
                </a-select-option>
              </a-select> -->
            </a-form-model-item>
          </a-col>
          <a-col :span = "12">
            <a-form-model-item label="联系人:" prop="contacts">
              <a-input v-model="searchList.contacts" :allowClear="true"  placeholder="请输入联系人"/>
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row>
          <a-col :span = "12">
            <a-form-model-item label="联系方式:" prop="phoneNo">
              <a-input v-model="searchList.phoneNo" :allowClear="true"  placeholder="请输入联系方式"/>
            </a-form-model-item>
          </a-col>
          <a-col :span = "12">
            <a-form-model-item label="入驻时间:" prop="joinDate">
              <a-date-picker v-model="searchList.joinDate" :allowClear="true" style="width: 285px;" placeholder="请选择入驻时间"/>
            </a-form-model-item>
          </a-col>
          <a-col :span = "12" v-if="this.modalTitle == '编辑客户信息'">
            <a-form-model-item label="认证状态:" prop="authStatus">
              <a-select v-model="searchList.authStatus" placeholder="请选择认证状态">
                <a-select-option v-for="item in authStatusList" :key="item.value" :value="item.value" style="width: 120px">
                    {{ item.label }}
                </a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col>
        </a-row>
      </a-form-model>
    </div>
    <template #footer>
      <!-- 底部按钮区域 -->
      <a-button  type="primary" ghost @click="handleCancel">取消</a-button>
      <a-button  type="primary" @click="handleOk">确定</a-button>
    </template>
    </a-modal>
  </div>
</template>

<script>
import moment from 'moment';
import { DictionaryService } from "@common/services/dictionary.service";
export default {
  components: {
  },
  props: {
    modalTitle: {
      type: String,
      default: () => "",
    }, //标题
    data: {
      type: Object,
      default: () => {},
    },//返回信息
  },
  mounted() {
    // 获取字典
    DictionaryService.getAllNeedDic(["AUTH_STATUS"]).then((res) => {
      //认证状态
      this.authStatusList = DictionaryService.getOptions("AUTH_STATUS");;

      if (this.modalTitle == "编辑客户信息") {
        this.searchList = this.data;
      }
    });
  },
  data() {
    return {
      visible: true,

      //固定宽度
      labelCol: { span: 6 },
      wrapperCol: { span: 17 },

      //绑定值
      searchList: {
        comName: "",
        uscc: "",
        location: "",
        contacts: "",
        phoneNo:"",
        joinDate: "",
      },

      //认证状态
      authStatusList:[],

      //校验规则
      rules: {
        comName: [
          {
            required: true,
            message: "企业名称不能为空！",
            trigger: "blur",
          },
          {
            max: 50,
            message: "不可超过50字",
            trigger: "blur",
          }
        ],
        uscc: [
          {
            max: 50,
            message: "不可超过50字",
            trigger: "blur",
          }
        ],
        location: [
          {
            max: 30,
            message: "不可超过30字",
            trigger: "blur",
          }
        ],
        contacts: [
          {
            required: true,
            message: "联系人不能为空！",
            trigger: "blur",
          },
          {
            max: 10,
            message: "不可超过10字",
            trigger: "blur",
          }
        ],
        phoneNo: [
          {
            required: true,
            message: "联系方式不能为空！",
            trigger: "blur",
          },
          {
            max: 20,
            message: "不可超过20字",
            trigger: "blur",
          }
        ],
        authStatus: [
          {
            required: true,
            message: "认证状态不能为空！",
            trigger: "blur",
          },
        ],
      },
    }
  },
  methods: {
    //取消
    handleCancel() {
      //关闭弹窗
      this.$emit("close");
    },

    //保存
    handleOk() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          this.searchList.joinDate = this.searchList.joinDate ? moment(this.searchList.joinDate).format("YYYY-MM-DD") : '';
          this.$emit("handleOk",this.searchList); 
        }
      });
    },

  },
}
</script>

<style scoped>
.button-save {
  border: none;
  background: #009de5;
  color: #fff;
  width: 90px;
  height: 30px;
}

.button-cancel {
  border: 1px #cccccc solid;
  background: #fff;
  color: #333;
  width: 90px;
  height: 30px;
}
</style>
